import { PRODUCT } from "~/constants/products";

export const META_PIXELS = {
    DEFAULT: "863787678512499",
    OESTRA_CREAM: "1173011655900523",
    LIBIDA: "1548512800284092",
    FACE_CREAM: "1689887645353859",
    NAD: "",
} as const;

/**
 * Meta (Facebook) pixels to fire for each product family, keyed by product slug
 * (`PRODUCT.*`). This is a marketing concern shared across domains — the quiz
 * funnel and checkout both resolve the same table, only from different inputs
 * (quiz keys off `QUIZ_CATEGORIES`, checkout off the product slug). It lives
 * here as a neutral leaf so any domain can reach it.
 *
 * NAD intentionally has no Meta pixel (empty list), so nothing fires for it.
 */
export const PRODUCT_META_PIXELS: Record<string, string[]> = {
    [PRODUCT.OESTRA_CREAM]: [META_PIXELS.OESTRA_CREAM],
    [PRODUCT.LIBIDA]: [META_PIXELS.LIBIDA],
    [PRODUCT.FACE_CREAM]: [META_PIXELS.FACE_CREAM],
    [PRODUCT.NAD]: [],
};
